const INITIAL_STATE ={
    notificacoesState : false,
    newNotify: true,
    numberOfNewNotify: 10
}
export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case 'CHANGE_NOTIFY_STATE':
            return { ...state, notificacoesState: action.payload }
        case 'SHOW_NEW_NOTIFY':
            return { ...state, newNotify: action.payload }
        case 'NUMBER_NEW_NOTIFY':
            return { ...state, numberOfNewNotify: action.payload }
        default: 
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/notificacoes.js